module.exports = __webpack_public_path__ + "img/walmart-coca-logo-footer.f29cf7f7.jpg";